/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-case-declarations */
import NegotiationForm from "./components/NegotiationForm";
import "./style.scss";
import { Input } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import ResponseAlert from "~components/Form/components/ResponseAlert";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import InformacoesAdicionaisModal from "../../components/Modal/InformacoesAdicionaisModal";
import StatusModal from "~components/Modal/ModalStatus";
import ModalResponse from "~components/Modal/ModalResponse";
import ModalAction from "~components/Modal/ModalAction";
import CondicaoEspecialModal from "../../components/Modal/CondicaoEspecialModal";
import useCliente from "~/fetchs/useCliente";
import { useConfigureFooter } from "~hooks/useHelpers";
import { GetIndexBD } from "~services/utils/GetIndexBD";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import useSubGrupoMaterial from "~/fetchs/useSubGrupoMaterial";
import useFilial from "~/fetchs/useFilial";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import usePrecoRegra from "~/fetchs/usePrecoRegra";
import usePrazoPagamento from "~/fetchs/usePrazoPagamento";
import { useSalvarNegociacao, useGetBeneficioFiscal } from "~pages/PricesTableV2/hooks/usePricesTableQuery";
import useTipoCondicao from "~/fetchs/useTipoCondicao";
import LoaderFull from "~components/Form/components/LoaderFull";
import useHierarquia from "~/fetchs/useHierarquia";
import useProdutoFilial from "~/fetchs/useProdutoFilial";
import { calcPercent } from "~services/GlobalServices";
import usePrecoCliente, { ArrumaDesconto } from "~fetchs/usePrecoCliente";
import useCalculateDiscount from "~pages/Simulators/hooks/useCalculateDiscount";
import useProdutoFilialPrecoRegraMicrorregiao from "~/fetchs/useProdutoFilialPrecoRegraMicrorregiao";
import apiGenericClient from "~services/utils/apiGenericClient";
import HeaderNegotiations from "./components/HeaderNegotiations";
import ReplicationSection from "./components/ReplicationSection";

const PricesTableNegotiation = () => {
  useConfigureFooter({
    form: true,
    formId: "nova-negociacao",
  });

  const navigate = useNavigate();

  const location = useLocation();
  const path = location.pathname;
  const initialPath = "/tabela-preco";

  const { id: clienteId, negociacao: negociacaoId } = useParams();
  const { cliente } = useCliente(clienteId);

  const { precoCliente } = usePrecoCliente({ id: parseInt(clienteId) });

  const [isLoading, setIsLoading] = useState(false);

  const [origemNegociacao] = useState("NovaNegociacao");
  const [initialData, setInitialData] = useState({});

  const [carregouPrecoAprovadoCliente, setCarregouPrecoAprovadoCliente] = useState(false);

  const [faixa, setFaixa] = useState(false);
  const [condicaoEspecial, setCondicaoEspecial] = useState(false);

  const [enableFetchBeneficioFiscal, setEnableFetchBeneficioFiscal] = useState(false);
  const [wasBeneficioChecked, setWasBeneficioChecked] = useState(false);
  const [valorBeneficioFiscal, setValorBeneficioFiscal] = useState({ cif: 0, fob: 0 });
  const [isLoadingBeneficioFiscal, setIsLoadingBeneficioFiscal] = useState(false);

  const { precosRegraDisponiveis, filiaisDisponiveis, gruposMateriaisDisponiveis, produtosDisponiveis } =
    useProdutoFilialPrecoRegraMicrorregiao({ microrregiaoId: cliente?.microrregiaoId });

  const {
    descontoCif,
    setDescontoCif,
    descontoFob,
    setDescontoFob,
    precoFinalCif,
    setPrecoFinalCif,
    precoFinalFob,
    setPrecoFinalFob,
    precoRegraCif,
    setPrecoRegraCif,
    precoRegraFob,
    setPrecoRegraFob,
    setIsEditingDesconto,
    setIsEditingPrecoFinal,
  } = useCalculateDiscount(faixa, condicaoEspecial);

  const [responseShow, setResponseShow] = useState(true);

  const [tipoProposta, setTipoProposta] = useState("");

  const [negociacao, setNegociacao] = useState({});
  const [infoAdicionais, setInfoAdicionais] = useState({});

  const [isOpenInfoAdicionaisModal, setIsOpenInfoAdicionaisModal] = useState(false);
  const [messageStatusModal, setMessageStatusModal] = useState("Solicitação enviada com sucesso!");
  const [isOpenStatusModal, setIsOpenStatusModal] = useState(false);
  const [modalErrorResponse, setModalErrorResponse] = useState({ isOpen: false, message: "" });
  const [modalValidacao, setModalValidacao] = useState({ isOpen: false, message: "" });
  const [modalValidacaoError, setModalValidacaoError] = useState({ isOpen: false, message: "" });
  const [isOpenCondicaoEspecialModal, setIsOpenCondicaoEspecialModal] = useState(false);

  const [initializedData] = useState(false);
  const [initializedProductGroup, setInitializedProductGroup] = useState(false);
  const [initializedProduct, setInitializedProduct] = useState(false);
  const [initializedBranch, setInitializedBranch] = useState(false);
  const [initializedBusinessType, setInitializedBusinessType] = useState(false);

  const [grupoProdutoDisabled, setGrupoProdutoDisabled] = useState(true);
  const [produtosDisabled, setProdutosDisabled] = useState(true);
  const [familiaProdutoDisabled, setFamiliaProdutoDisabled] = useState(true);
  const [grupoCentralizadorDisabled, setGrupoCentralizadorDisabled] = useState(true);
  const [centroCEDisabled, setCentroCEDisabled] = useState(true);

  const [showOverlay, setShowOverlay] = useState({
    fob: false,
    cif: false,
  });

  const [microrregiao, setMicrorregiao] = useState(0);
  const [cluster, setCluster] = useState(0);

  const formikRef = useRef();

  //FILTRO
  const { grupoProduto, grupoProdutoSelect, optionGruposProduto, SetSelectGrupoProduto, onChangeGrupoProduto } =
    useGrupoProduto({ formikRef: formikRef, camposOpt: ["nome"] });

  const {
    filiais: filiaisE,
    filial,
    optionFiliais: optionFiliaisE,
    onChangeFilial,
    filialSelect: filialSelectE,
    SetSelectFilial: SetSelectFilialE,
  } = useFilial({ formikRef, filiaisDisponiveis });

  const { produto, produtoSelect, optionProdutos, SetSelectProduto, onChangeProduto } = useProduto({
    formikRef: formikRef,
    grupoProduto: grupoProduto,
    camposOpt: ["codigo", "descricaoProduto"],
  });

  const { tipoCondicoes } = useTipoCondicao(null);

  //FORMULÁRIO
  const { onChangePrazoPagamento: onChangePrazoPagamentoCIF } = usePrazoPagamento(formikRef, "prazoPagamentoCifId");
  const { onChangePrazoPagamento: onChangePrazoPagamentoFOB } = usePrazoPagamento(formikRef, "prazoPagamentoFobId");
  const {
    prazoPagamentos,
    onChangePrazoPagamento,
    prazoPagamentoSelect,
    optionPrazosPagamento,
    setSelectPrazoPagamento,
  } = usePrazoPagamento(formikRef);

  //REPLICAÇÃO
  const { optionFiliais: optionFiliaisReplicacao, onChangeFilial: onChangeFilialReplicacao } = useFilial({
    formikRef,
    filiaisDisponiveis: filiaisDisponiveis,
  });
  const { optionSubGrupoMateriais, subGrupoMaterialSelect, onChangeSubGrupoMaterial } = useSubGrupoMaterial({
    formikRef,
    filialForm: filial,
    name: "subGrupoMaterialReplicacaoId",
    gruposMateriaisDisponiveis,
    replicacao: true,
  });
  const {
    gruposProduto: gruposProdutoReplicacao,
    optionGruposProduto: optionGruposProdutoReplicacao,
    grupoProdutoSelect: grupoProdutoReplicacaoSelect,
    onChangeGrupoProduto: onChangeGrupoProdutoReplicacao,
    grupoProduto: grupoProdutoReplicacao,
  } = useGrupoProduto({
    formikRef,
    name: "grupoProdutoReplicacaoId",
    filiais: filiaisE,
    filial: filial,
    gruposDisponiveis: gruposMateriaisDisponiveis,
    camposOpt: ["nome"],
    replicacao: true,
  });

  const { optionProdutos: optionProdutosReplicacao, onChangeProduto: onChangeProdutoReplicacao } = useProduto({
    grupoProduto: grupoProdutoReplicacao,
    gruposProduto: gruposProdutoReplicacao,
    filialForm: filial,
    produtosDisponiveis,
    formikRef,
    type: "geral",
    name: "produtoReplicacaoId",
    camposOpt: ["codigo", "descricaoProduto"],
    typeOptions: "multi",
    replicacao: true,
  });
  const {
    optionGruposCentralizadores: optionGruposCentralizadoresReplicacao,
    onChangeGrupoCentralizador: onChangeGrupoCentralizadorReplicacao,
    grupoCentralizadorSelect: grupoCentralizadorReplicacaoSelect,
  } = useGrupoCentralizador(formikRef, "grupoCentralizadorReplicacaoId");

  const optionFiliaisReplicacaoFiltered = useMemo(() => {
    return (optionFiliaisReplicacao || []).filter((optFilial) => {
      const precosProdutoCheck = (precosRegraDisponiveis || []).some(
        (pp) => pp.produtoId == produto && pp.filialId === optFilial.value
      );
      return optFilial.value !== filial && precosProdutoCheck;
    });
  }, [optionFiliaisReplicacao, precosRegraDisponiveis, produto]);

  const [filiaisReplicacao, setFiliaisReplicacao] = useState([]);

  function onChangeFilialReplicacaoMulti(e) {
    let filiaisIds = "";
    e?.forEach((fReplicacao) => {
      filiaisIds += !filiaisIds ? fReplicacao.value : `,${fReplicacao.value}`;
    });

    setFiliaisReplicacao(filiaisIds?.split(","));
    onChangeFilialReplicacao({ label: "Filiais Selecionadas", value: filiaisIds });
  }

  const [produtoReplicacao, setProdutoReplicacao] = useState([]);

  function onChangeProdutoReplicacaoMulti(e) {
    let produtosIds = "";
    e?.forEach((pReplicacao) => {
      produtosIds += !produtosIds ? pReplicacao.value : `,${pReplicacao.value}`;
    });

    setProdutoReplicacao(produtosIds?.split(","));
    onChangeProdutoReplicacao({ label: "Produtos Selecionados", value: produtosIds });
  }

  const { produtoNaFilial } = useProdutoFilial({ filial: filial, produtoId: produto });

  const { precoRegra } = usePrecoRegra({
    produto: produto,
    filial: filial,
    microrregiao: microrregiao,
    cluster: cluster,
    cidade: cliente?.endereco?.cidade?.id,
    setLoading: setIsLoading,
  });

  const [precoAprovadoCif, setPrecoAprovadoCif] = useState(0);
  const [precoAprovadoFob, setPrecoAprovadoFob] = useState(0);

  const getTipoCondicaoIds = () => {
    const faixa = tipoCondicoes?.find((e) => e.nome.toLowerCase() === "faixa")?.id;
    const ce = tipoCondicoes?.find((e) => e.nome.toLowerCase() === "condição especial")?.id;
    return { faixa, ce };
  };

  const findPrecoClienteFaixa = (precoCliente, tipoCondicaoFaixaId, produtoNaFilial, produto) => {
    let faixa = (precoCliente || []).find(
      (pc) =>
        tipoCondicaoFaixaId && pc.tipoCondicaoId === tipoCondicaoFaixaId && pc.produtoFilialId === produtoNaFilial?.id
    );
    if (!faixa) {
      faixa = (precoCliente || []).find(
        (pc) => tipoCondicaoFaixaId && pc.tipoCondicaoId === tipoCondicaoFaixaId && pc.produtoId === produto
      );
    }
    return faixa;
  };

  const findPrecoClienteCE = (precoCliente, tipoCondicaoCEId, produtoNaFilial) =>
    (precoCliente || []).find(
      (pc) => tipoCondicaoCEId && pc.tipoCondicaoId === tipoCondicaoCEId && pc.produtoFilialId === produtoNaFilial?.id
    );

  const handleFaixa = (precoClienteFaixa, precoClienteCE, name) => {
    if ((precoClienteFaixa?.faixa || precoClienteCE?.faixa) && name === "faixa") {
      const descontoFaixa = precoClienteCE?.faixa ?? precoClienteFaixa?.faixa;
      setDescontoCif(ArrumaDesconto(descontoFaixa));
      setDescontoFob(ArrumaDesconto(descontoFaixa));
      setPrecoAprovadoCif(precoClienteFaixa?.precoFinalCIF ?? 0);
      setPrecoAprovadoFob(precoClienteFaixa?.precoFinalFOB ?? 0);
      return true;
    }
    return false;
  };

  const handleCondicaoEspecial = (precoClienteCE, name) => {
    if (
      (precoClienteCE?.precoFinalCIF || precoClienteCE?.precoFinalFOB) &&
      !(carregouPrecoAprovadoCliente && name === "faixa")
    ) {
      if (precoClienteCE.desconto) {
        setDescontoCif(ArrumaDesconto(precoClienteCE.desconto));
        setDescontoFob(ArrumaDesconto(precoClienteCE.desconto));
      }
      setPrecoAprovadoCif(precoClienteCE.precoFinalCIF ?? 0);
      setPrecoAprovadoFob(precoClienteCE.precoFinalFOB ?? 0);
      const overlay = { fob: false, cif: false };
      if (precoClienteCE?.precoFinalCIF) {
        setPrecoFinalCif(precoClienteCE.precoFinalCIF);
        formikRef.current?.setFieldValue("precoFinalCif", precoClienteCE.precoFinalCIF);
        if (precoClienteCE.precoFinalCIF && precoRegraCif) {
          const desconto = (precoClienteCE.precoFinalCIF / precoRegraCif - 1) * 100;
          setDescontoCif(desconto.toFixed(2));
        }
      }
      if (precoClienteCE?.precoFinalFOB) {
        setPrecoFinalFob(precoClienteCE.precoFinalFOB);
        formikRef.current?.setFieldValue("precoFinalFob", precoClienteCE.precoFinalFOB);
        if (precoClienteCE.precoFinalFOB && precoRegraFob) {
          const desconto = (precoClienteCE.precoFinalFOB / precoRegraFob - 1) * 100;
          setDescontoFob(desconto.toFixed(2));
        }
      }
      setShowOverlay(overlay);
      return true;
    }
    return false;
  };

  const atualizaPrecoAprovado = useCallback(
    (name) => {
      if (!precoCliente) return;
      const { faixa: tipoCondicaoFaixaId, ce: tipoCondicaoCEId } = getTipoCondicaoIds();
      const precoClienteFaixa = findPrecoClienteFaixa(precoCliente, tipoCondicaoFaixaId, produtoNaFilial, produto);
      const precoClienteCE = findPrecoClienteCE(precoCliente, tipoCondicaoCEId, produtoNaFilial);

      let temPrecoAprovado = false;
      if (handleFaixa(precoClienteFaixa, precoClienteCE, name)) {
        if (!carregouPrecoAprovadoCliente) {
          setFaixa(true);
          setCondicaoEspecial(false);
          temPrecoAprovado = true;
        }
      }
      if (handleCondicaoEspecial(precoClienteCE, name)) {
        if (!carregouPrecoAprovadoCliente) {
          setFaixa(false);
          setCondicaoEspecial(true);
          temPrecoAprovado = true;
        }
      }
      if (!carregouPrecoAprovadoCliente) {
        setCarregouPrecoAprovadoCliente(temPrecoAprovado);
      }
    },
    [
      precoCliente,
      tipoCondicoes,
      produtoNaFilial?.id,
      produto,
      carregouPrecoAprovadoCliente,
      setDescontoCif,
      setDescontoFob,
      setPrecoAprovadoCif,
      setPrecoAprovadoFob,
      setPrecoFinalCif,
      setPrecoFinalFob,
      setShowOverlay,
      setFaixa,
      setCondicaoEspecial,
      precoRegraCif,
      precoRegraFob,
      formikRef,
      setCarregouPrecoAprovadoCliente,
    ]
  );

  useEffect(() => {
    const name = formikRef.current?.values?.tipoProposta;
    atualizaPrecoAprovado(name);
  }, [
    precoCliente,
    precoRegraCif,
    precoRegraFob,
    faixa,
    condicaoEspecial,
    tipoCondicoes,
    produtoNaFilial?.id,
    formikRef.current?.values?.tipoProposta,
  ]);

  useEffect(() => {
    formikRef.current.values.tipoProposta = faixa ? "faixa" : "condicaoEspecial";
  }, [faixa, condicaoEspecial]);

  const isEdicao = useCallback(() => {
    return path.startsWith(`${initialPath}/`) && path.endsWith("/editar-negociacao");
  }, [path, initialPath]);

  useEffect(() => {
    if (isEdicao()) {
      if (condicaoEspecial && precoCliente) {
        const precoClienteItem = (precoCliente || []).find(
          (pc) =>
            pc.produtoId === initialData?.produtoId &&
            pc.clienteId === initialData?.clienteId &&
            pc.filialId === initialData?.filialId
        );
        const prazoCifId = precoClienteItem?.prazoPagamentoCIFId || null;
        const prazoFobId = precoClienteItem?.prazoPagamentoFOBId || null;

        if (formikRef.current && (prazoCifId || prazoFobId)) {
          if (!("prazoCif" in formikRef.current.values)) {
            formikRef.current.values.prazoCif = !!prazoCifId;
          }
          if (!("prazoFob" in formikRef.current.values)) {
            formikRef.current.values.prazoFob = !!prazoFobId;
          }

          setSelectPrazoPagamento((prazoCifId || prazoFobId) ?? 0);
        }
      }
    }
  }, [precoCliente, prazoPagamentos, condicaoEspecial]);

  const [prazoPagamentoObj, setPrazoPagamentoObj] = useState({
    prazoPagamentoCif: "",
    prazoPagamentoCifValor: null,
    prazoPagamentoFob: "",
    prazoPagamentoFobValor: null,
  });

  const prazos = useMemo(() => {
    let prazosListing = [];
    if (prazoPagamentoObj.prazoPagamentoCif !== "")
      prazosListing.push({
        grupoProdutoId: grupoProduto ?? grupoProduto,
        prazosPagamentoId: [prazoPagamentoObj.prazoPagamentoFobValor],
      });

    if (prazoPagamentoObj.prazoPagamentoFob !== "")
      prazosListing.push({
        grupoProdutoId: grupoProduto ?? grupoProduto,
        prazosPagamentoId: [prazoPagamentoObj.prazoPagamentoFobValor],
      });
    return prazosListing;
  }, [grupoProduto, prazoPagamentoObj]);

  const descontosMaximo = useMemo(() => {
    let _descontoFob = precoFinalFob == 0 ? -100 : calcPercent(precoFinalFob, precoRegraFob);
    let _descontoCif = precoFinalCif == 0 ? -100 : calcPercent(precoFinalCif, precoRegraCif);
    let retornoDesconto = null;

    _descontoFob = _descontoFob.toFixed(2);
    _descontoCif = _descontoCif.toFixed(2);

    if (faixa)
      retornoDesconto = [
        {
          grupoProdutoId: grupoProduto,
          descontos: [descontoFob],
        },
      ];
    else
      retornoDesconto = [
        {
          grupoProdutoId: grupoProduto,
          descontos: [Math.min(_descontoFob, _descontoCif)],
        },
      ];
    return retornoDesconto;
  }, [grupoProduto, descontoFob, precoFinalFob, precoFinalCif, tipoProposta]);

  const { hierarquiasAprovacaoMaxima } = useHierarquia({
    descontosMaximo,
    prazos,
  });

  const handleChangeTipoReplicacao = useCallback(
    (value) => {
      const types = {
        grupoProdutoDisabled: {
          fn: setGrupoProdutoDisabled,
          value: grupoProdutoDisabled,
        },
        produtosDisabled: {
          fn: setProdutosDisabled,
          value: produtosDisabled,
        },
        familiaProdutoDisabled: {
          fn: setFamiliaProdutoDisabled,
          value: familiaProdutoDisabled,
        },
        grupoCentralizadorDisabled: {
          fn: setGrupoCentralizadorDisabled,
          value: grupoCentralizadorDisabled,
        },
        centroCEDisabled: {
          fn: setCentroCEDisabled,
          value: centroCEDisabled,
        },
      };

      if (value !== "grupoCentralizadorDisabled") Object.keys(types).forEach((e) => types[e].fn(true)); //DISABLED

      if (value && types[value]) {
        types[value].fn(!types[value].value);
      }
    },
    [grupoProdutoDisabled, produtosDisabled, familiaProdutoDisabled, grupoCentralizadorDisabled, centroCEDisabled]
  );

  const handleConfirm = () => {
    formikRef.current.values.tipoProposta = "condicaoEspecial";
    setTipoProposta("condicaoEspecial");
    setIsOpenCondicaoEspecialModal(false);
  };

  const handleCancel = () => {
    formikRef.current.values.tipoProposta = faixa ? "faixa" : "condicaoEspecial";
    setIsOpenCondicaoEspecialModal(false);
  };

  const getReplicacaoValidationMessage = (values) => {
    if (!familiaProdutoDisabled && !values.subGrupoMaterialReplicacaoId)
      return "Selecione uma família de produto para replicação!";
    if (!grupoCentralizadorDisabled && !values.grupoCentralizadorReplicacaoId)
      return "Selecione um grupo centralizador para replicação!";
    if (!grupoProdutoDisabled && !values.grupoProdutoReplicacaoId)
      return "Selecione um grupo de produto para replicação!";
    if (!produtosDisabled && !produtoReplicacao?.filter((p) => p)?.length)
      return "Selecione um produto para replicação!";
    if (!centroCEDisabled && !filiaisReplicacao?.filter((fr) => fr)?.length)
      return "Selecione um centro para replicação!";
    return "";
  };

  const buildFaixaPayload = (toSend, values) => ({
    ...toSend,
    descontoCif: descontoCif,
    descontoFob: descontoFob,
    subGrupoMaterial: !familiaProdutoDisabled ? [values.subGrupoMaterialReplicacaoId] : [],
    gruposCentralizadores: !grupoCentralizadorDisabled ? [values.grupoCentralizadorReplicacaoId] : [],
    gruposProduto: !grupoProdutoDisabled ? [values.grupoProdutoReplicacaoId] : [],
    produtos: !produtosDisabled ? produtoReplicacao : [],
  });

  const buildCondicaoEspecialPayload = (toSend) => ({
    ...toSend,
    descontoCif: descontoCif,
    descontoFob: descontoFob,
    filiais: !centroCEDisabled ? filiaisReplicacao : [],
  });

  const handleSubmit = useCallback(
    (values) => {
      const toSendBase = {
        id: 0,
        tipoProposta: values.tipoProposta,
        grupoProdutoId: values.grupoProdutoId,
        produtoId: values.produtoId,
        filialId: filial,
        precoRegraCif: precoRegraCif,
        precoRegraFob: precoRegraFob,
        descontoCif: 0,
        descontoFob: 0,
        precoFinalCif: precoFinalCif,
        precoFinalFob: precoFinalFob,
        prazoPagamentoCifId: values.prazoCif ? values.prazoPagamentoId : null,
        prazoPagamentoFobId: values.prazoFob ? values.prazoPagamentoId : null,
        clienteId: parseInt(clienteId),
        aprovadorMaximoId: null,
        tipoCondicaoId:
          tipoCondicoes.find(
            (e) =>
              e.nome
                .toLowerCase()
                .replace(/\s+/g, "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") == values.tipoProposta.toLowerCase()
          )?.id || null,
        origem: origemNegociacao == "NovaNegociacao" ? 1 : 2,
        beneficioFiscalCif: enableFetchBeneficioFiscal ? valorBeneficioFiscal.cif : null,
        beneficioFiscalFob: enableFetchBeneficioFiscal ? valorBeneficioFiscal.fob : null,
      };

      const mensagem = getReplicacaoValidationMessage(values);
      if (mensagem) {
        setModalValidacaoError({ isOpen: true, message: mensagem });
        return;
      }

      let toSend = toSendBase;
      if (values.tipoProposta === "faixa") {
        toSend = buildFaixaPayload(toSendBase, values);
      } else if (values.tipoProposta === "condicaoEspecial") {
        toSend = buildCondicaoEspecialPayload(toSendBase);
      }
      setNegociacao(toSend);
    },
    [
      descontoCif,
      descontoFob,
      precoFinalCif,
      precoFinalFob,
      precoRegraCif,
      precoRegraFob,
      filial,
      clienteId,
      tipoCondicoes,
      origemNegociacao,
      enableFetchBeneficioFiscal,
      valorBeneficioFiscal,
      familiaProdutoDisabled,
      grupoCentralizadorDisabled,
      grupoProdutoDisabled,
      produtosDisabled,
      centroCEDisabled,
      filiaisReplicacao,
      produtoReplicacao,
      setModalValidacaoError,
      setNegociacao,
    ]
  );

  const onSuccess = (data) => {
    if (data.isOffline) {
      setMessageStatusModal(
        "Solicitação armazenada offline e será enviada para o servidor assim que a conexão estiver estabelecida"
      );
      setIsLoading(false);
      setIsOpenStatusModal(true);
    } else {
      const codigosExternos = (data || []).map((item) => item?.codigoExterno);
      setMessageStatusModal("Solicitação enviada com sucesso! " + codigosExternos.join(", "));
      setIsLoading(false);
      setIsOpenStatusModal(true);
    }
  };

  const onErro = (data) => {
    setModalErrorResponse({ isOpen: !data?.isSuccess, message: data?.message });
    setIsLoading(false);
  };

  useSalvarNegociacao(infoAdicionais, onSuccess, onErro);

  const handleEnviarNegociacao = (e) => {
    setIsLoading(true);

    const item = {
      ...negociacao,
      ...e,
    };

    setInfoAdicionais(item);
  };

  const initializeHeaderSelects = async (key, setter, initializer) => {
    const value = initialData?.[key];
    if (value) {
      setter(value);
      initializer(true);
    }
  };

  const fetchPreco = useCallback(
    (_desconto = false) => {
      setPrecoRegraFob(precoRegra?.valorPrecoFOB);
      setPrecoRegraCif(precoRegra?.valorPrecoCIF);
      setPrecoFinalFob(precoRegra?.valorPrecoFOB);
      setPrecoFinalCif(precoRegra?.valorPrecoCIF);
    },
    [precoRegra, setPrecoRegraFob, setPrecoRegraCif, setPrecoFinalFob, setPrecoFinalCif]
  );

  const isOnlyPrazo = (negociacao, showOverlay) => {
    return (negociacao.prazoPagamentoCifId || negociacao.prazoPagamentoFobId) && (!showOverlay.cif || !showOverlay.fob);
  };

  const isNoPrazoOrDesconto = (negociacao) => {
    return !negociacao.prazoPagamentoCifId && !negociacao.prazoPagamentoFobId;
  };

  const isOnlyOneCondicao = (temNegociacaoCif, temNegociacaoFob, showOverlay) => {
    return (
      (temNegociacaoCif && !temNegociacaoFob && !showOverlay.fob) ||
      (!temNegociacaoCif && !showOverlay.cif && temNegociacaoFob)
    );
  };

  useEffect(() => {
    if (!(negociacao && (Object.entries(negociacao) || []).length > 0)) return;
    const temNegociacaoCif = negociacao.descontoCif != 0 && negociacao.precoFinalCif != 0;
    const temNegociacaoFob = negociacao.descontoFob != 0 && negociacao.precoFinalFob != 0;

    let mensagem = "";
    let isError = false;

    if (!temNegociacaoCif && !temNegociacaoFob) {
      if (isOnlyPrazo(negociacao, showOverlay)) {
        mensagem = "Você está enviando apenas condição especial de prazo, confirma o envio?";
      } else if (isNoPrazoOrDesconto(negociacao)) {
        isError = true;
        setModalValidacaoError({
          isOpen: true,
          message: "Preencha algum dado de negociação ou desconto para fazer o envio da negociação!",
        });
      }
    } else if (isOnlyOneCondicao(temNegociacaoCif, temNegociacaoFob, showOverlay)) {
      mensagem = `Você está enviando apenas condição especial ${temNegociacaoCif ? "CIF" : "FOB"}, confirma o envio?`;
    }

    if (mensagem) setModalValidacao({ isOpen: true, message: mensagem });
    else if (!isError) setIsOpenInfoAdicionaisModal(true);
  }, [negociacao]);

  useEffect(() => {
    if (infoAdicionais && (Object.entries(infoAdicionais) || []).length > 0) {
      setIsOpenInfoAdicionaisModal(false);
      setIsLoading(true);

      if (origemNegociacao === "NovaNegociacao") {
        salvarNegociacao(infoAdicionais);
      }
    }
  }, [infoAdicionais]);

  const salvarNegociacao = async (data) => {
    const client = new apiGenericClient("simulacao", "/api/TabelaPreco");
    const response = await client.createData(data);

    if (response?.isSuccess === false) {
      return onErro(response);
    }
    return response?.data === undefined ? onErro(response) : onSuccess(response.data);
  };

  useLayoutEffect(() => {
    if (!initializedData && (Object.entries(initialData) || []).length == 0) {
      GetIndexBD("dados-selecionados-negociacao").then((e) => {
        setTipoProposta("faixa");
        setInitialData(e);
      });
    }
  }, []);

  useEffect(() => {
    if (initialData && (Object.entries(initialData) || []).length > 0) {
      if ((optionGruposProduto || []).length > 0 && !initializedProductGroup) {
        initializeHeaderSelects("grupoProdutoId", SetSelectGrupoProduto, setInitializedProductGroup);
      }
      if ((optionProdutos || []).length > 0 && !initializedProduct) {
        initializeHeaderSelects("produtoId", SetSelectProduto, setInitializedProduct);
      }
      if (filial == 0 && !initializedBranch) {
        initializeHeaderSelects("filialId", SetSelectFilialE, setInitializedBranch);
      }
    }
  }, [optionGruposProduto, optionProdutos, initialData]);

  useEffect(() => {
    if (formikRef?.current && tipoProposta) {
      if (!initializedBusinessType) {
        formikRef.current.values.tipoProposta = tipoProposta;
        setInitializedBusinessType(true);
      }
    }
  }, [tipoProposta, formikRef]);

  const handleChangeTipoProposta = useCallback(
    (resetValue) => {
      const name = formikRef.current.values.tipoProposta != "faixa" ? "faixa" : "especial";
      if ((name == "faixa" && resetValue) || name == "manter") {
        setDescontoCif(0);
        setDescontoFob(0);
      }

      if (name == "especial") {
        setShowOverlay({
          fob: true,
          cif: true,
        });
        if (descontoCif || descontoFob !== 0) {
          setDescontoFob(0);
          setDescontoCif(0);
          setPrecoFinalFob(0);
          setPrecoFinalCif(0);
        }

        formikRef.current?.setFieldValue("grupoProdutoReplicacaoBool", false);
        formikRef.current?.setFieldValue("familiaProdutoReplicacaoBool", false);
        formikRef.current?.setFieldValue("produtoReplicacaoBool", false);
        formikRef.current?.setFieldValue("grupoCentralizadorReplicacaoBool", false);
      } else {
        setShowOverlay({
          fob: false,
          cif: false,
        });

        onChangePrazoPagamentoCIF({ label: "", value: 0 });
        onChangePrazoPagamentoFOB({ label: "", value: 0 });
        formikRef.current?.setFieldValue("prazoPagamentoCifId", false);
        formikRef.current?.setFieldValue("prazoPagamentoFobId", false);
      }

      setDescontoFob(0);
      setDescontoCif(0);
      atualizaPrecoAprovado(name);
    },
    [
      formikRef,
      descontoCif,
      descontoFob,
      setDescontoCif,
      setDescontoFob,
      setShowOverlay,
      setPrecoFinalFob,
      setPrecoFinalCif,
      onChangePrazoPagamentoCIF,
      onChangePrazoPagamentoFOB,
      atualizaPrecoAprovado,
    ]
  );

  useEffect(() => {
    if (tipoProposta === "faixa") {
      const _precoFinalFob = precoRegraFob * (1 + descontoFob / 100);
      const _precoFinalCif = precoRegraCif * (1 + descontoCif / 100);
      setPrecoFinalFob(_precoFinalFob);
      setPrecoFinalCif(_precoFinalCif);
    }
  }, [descontoFob, descontoCif, precoRegraFob, precoRegraCif, tipoProposta, setPrecoFinalFob, setPrecoFinalCif]);

  useEffect(() => {
    let _precoFinalFob = 0,
      _precoFinalCif = 0,
      _descontoFob = 0,
      _descontoCif = 0;

    switch (tipoProposta) {
      case "faixa":
        _precoFinalFob = precoRegraFob * (1 + descontoFob / 100);
        _precoFinalCif = precoRegraCif * (1 + descontoCif / 100);
        setPrecoFinalFob(_precoFinalFob);
        setPrecoFinalCif(_precoFinalCif);
        break;
      case "condicaoEspecial":
        _descontoFob = precoFinalFob == 0 ? 100 : calcPercent(precoFinalFob, precoRegraFob);
        _descontoCif = precoFinalCif == 0 ? 100 : calcPercent(precoFinalCif, precoRegraCif);
        setDescontoFob(_descontoFob);
        setDescontoCif(_descontoCif);
        break;
      default:
        setDescontoFob(0);
        setDescontoCif(0);
        setPrecoFinalFob(precoRegraFob);
        setPrecoFinalCif(precoRegraCif);
        break;
    }
  }, [tipoProposta]);

  useEffect(() => {
    if (cliente != undefined) {
      setMicrorregiao(cliente.microrregiaoId);
      setCluster(cliente.clusterId);
    }
  }, [cliente]);

  useEffect(() => {
    if (produto || produto == 0) {
      setIsLoading(true);
    }
  }, [produto]);

  useEffect(() => {
    if (precoRegra && (Object.entries(precoRegra) || []).length > 0) {
      fetchPreco();
    }
  }, [precoRegra]);

  useEffect(() => {
    if (precoRegraFob || precoRegraCif) {
      setIsLoading(false);
    }
  }, [precoRegraCif, precoRegraFob]);

  useEffect(() => {
    if (!filialSelectE.initValue|| !grupoProdutoSelect.initValue || !produtoSelect.initValue) {
      setIsLoading(true);
    }
  }, [filialSelectE, grupoProdutoSelect, produtoSelect]);

  const aprovadorMaximo = useMemo(() => {
    if (hierarquiasAprovacaoMaxima && typeof hierarquiasAprovacaoMaxima == "object") {
      const aprovador = hierarquiasAprovacaoMaxima.find((a) => a.grupoProdutoId == grupoProduto);
      if (aprovador) return aprovador;
    }
  }, [hierarquiasAprovacaoMaxima]);

  function onChangeEnviaPrazo(e, type = "cif") {
    if (type === "cif") formikRef.current?.setFieldValue("prazoCif", e.target.checked);
    else if (type === "fob") formikRef.current?.setFieldValue("prazoFob", e.target.checked);
  }

  const beneficioFiscal = useGetBeneficioFiscal(enableFetchBeneficioFiscal, clienteId, filial, produto);

  useEffect(() => {
    if (enableFetchBeneficioFiscal) {
      if (
        clienteId &&
        filial &&
        produto &&
        !beneficioFiscal.isLoading &&
        !beneficioFiscal.isFetching &&
        !beneficioFiscal.isRefetching
      ) {
        setIsLoadingBeneficioFiscal(true);
        beneficioFiscal.refetch();
      }
    } else {
      setIsLoadingBeneficioFiscal(false);
    }
  }, [enableFetchBeneficioFiscal, clienteId, filial, produto]);

  const atualizaBeneficioFiscal = useCallback(() => {
    if (!enableFetchBeneficioFiscal || !beneficioFiscal.data) {
      return;
    }

    if (beneficioFiscal?.isSuccess) {
      const beneficio = beneficioFiscal.data;

      const beneficioCif = precoAprovadoCif
        ? precoFinalCif + (beneficio.valorBeneficioCif - precoAprovadoCif)
        : beneficio.valorBeneficioCif;
      const beneficioFob = precoAprovadoFob
        ? precoFinalFob + (beneficio.valorBeneficioFob - precoAprovadoFob)
        : beneficio.valorBeneficioFob;

      setValorBeneficioFiscal({
        cif: beneficio.valorBeneficioCif > 0 && beneficioCif != precoFinalCif ? beneficioCif : 0,
        fob: beneficio.valorBeneficioFob > 0 && beneficioFob != precoFinalFob ? beneficioFob : 0,
      });
    } else {
      setValorBeneficioFiscal({
        cif: 0,
        fob: 0,
      });
    }

    setIsLoadingBeneficioFiscal(false);
  }, [enableFetchBeneficioFiscal, beneficioFiscal, precoAprovadoCif, precoAprovadoFob, precoFinalCif, precoFinalFob]);

  useEffect(() => {
    if (beneficioFiscal.isLoading || beneficioFiscal.isFetching || beneficioFiscal.isRefetching) {
      setIsLoadingBeneficioFiscal(true);
    } else if (enableFetchBeneficioFiscal && beneficioFiscal.data) {
      atualizaBeneficioFiscal();
      setIsLoadingBeneficioFiscal(false);
    } else if (!enableFetchBeneficioFiscal) {
      setIsLoadingBeneficioFiscal(false);
    }
  }, [
    beneficioFiscal.data,
    beneficioFiscal.isLoading,
    beneficioFiscal.isFetching,
    beneficioFiscal.isRefetching,
    enableFetchBeneficioFiscal,
  ]);

  const enableBeneficio = useMemo(() => {
    const isFaixaOrCE =
      formikRef.current?.values?.tipoProposta === "faixa" ||
      formikRef.current?.values?.tipoProposta === "condicaoEspecial";
    if (!isFaixaOrCE) return false;

    const isZeroDiscount = descontoCif == 0 && descontoFob == 0;

    const matchesApprovedNegotiation =
      carregouPrecoAprovadoCliente &&
      precoFinalCif &&
      precoAprovadoCif &&
      parseFloat(precoFinalCif).toFixed(2) == parseFloat(precoAprovadoCif).toFixed(2) &&
      precoFinalFob &&
      precoAprovadoFob &&
      parseFloat(precoFinalFob).toFixed(2) == parseFloat(precoAprovadoFob).toFixed(2);

    return isZeroDiscount || matchesApprovedNegotiation;
  }, [
    carregouPrecoAprovadoCliente,
    descontoCif,
    descontoFob,
    precoFinalCif,
    precoFinalFob,
    precoAprovadoCif,
    precoAprovadoFob,
    formikRef,
  ]);

  useEffect(() => {
    if (enableFetchBeneficioFiscal && !wasBeneficioChecked) {
      setWasBeneficioChecked(true);
    } else if (!enableFetchBeneficioFiscal && wasBeneficioChecked && enableBeneficio) {
      setWasBeneficioChecked(false);
    }
  }, [enableFetchBeneficioFiscal]);

  return (
    <>
      <main className="prices-table-negotiation-page">
        <div className="container content">
          <HeaderNegotiations
            optionFiliaisE={optionFiliaisE}
            onChangeFilial={onChangeFilial}
            filialSelectE={filialSelectE}
            optionGruposProduto={optionGruposProduto}
            onChangeGrupoProduto={onChangeGrupoProduto}
            grupoProdutoSelect={grupoProdutoSelect}
            optionProdutos={optionProdutos}
            onChangeProduto={onChangeProduto}
            produtoSelect={produtoSelect}
          />

          <Formik initialValues={{ tipoCondicao: "" }} onSubmit={handleSubmit} innerRef={formikRef}>
            {({ handleChange, values, errors, touched }) => (
              <Form id="nova-negociacao">
                {precoRegra && precoRegraCif && precoRegraFob && !isLoading ? (
                  <NegotiationForm
                    precoRegra={precoRegra}
                    precoRegraCif={precoRegraCif}
                    precoRegraFob={precoRegraFob}
                    loading={isLoading}
                    values={values}
                    handleChange={handleChange}
                    handleChangeTipoProposta={handleChangeTipoProposta}
                    enableBeneficio={enableBeneficio}
                    enableFetchBeneficioFiscal={enableFetchBeneficioFiscal}
                    setEnableFetchBeneficioFiscal={setEnableFetchBeneficioFiscal}
                    wasBeneficioChecked={wasBeneficioChecked}
                    descontoFob={descontoFob}
                    setDescontoFob={setDescontoFob}
                    descontoCif={descontoCif}
                    setDescontoCif={setDescontoCif}
                    precoFinalFob={precoFinalFob}
                    setPrecoFinalFob={setPrecoFinalFob}
                    precoFinalCif={precoFinalCif}
                    setPrecoFinalCif={setPrecoFinalCif}
                    showOverlay={showOverlay}
                    setShowOverlay={setShowOverlay}
                    setIsEditingDesconto={setIsEditingDesconto}
                    setIsEditingPrecoFinal={setIsEditingPrecoFinal}
                    valorBeneficioFiscal={valorBeneficioFiscal}
                    loadingBeneficio={isLoadingBeneficioFiscal}
                    optionPrazosPagamento={optionPrazosPagamento}
                    onChangePrazoPagamento={onChangePrazoPagamento}
                    setPrazoPagamentoObj={setPrazoPagamentoObj}
                    prazoPagamentoSelect={prazoPagamentoSelect}
                    errors={errors}
                    touched={touched}
                    formikRef={formikRef}
                    onChangeEnviaPrazo={onChangeEnviaPrazo}
                  />
                ) : null}

                <ReplicationSection
                  negociacaoId={negociacaoId}
                  values={values}
                  // Condição Especial props
                  centroCEDisabled={centroCEDisabled}
                  handleChangeTipoReplicacao={handleChangeTipoReplicacao}
                  onChangeFilialReplicacaoMulti={onChangeFilialReplicacaoMulti}
                  optionFiliaisReplicacaoFiltered={optionFiliaisReplicacaoFiltered}
                  formikRef={formikRef}
                  // Faixa props
                  grupoProdutoDisabled={grupoProdutoDisabled}
                  familiaProdutoDisabled={familiaProdutoDisabled}
                  produtosDisabled={produtosDisabled}
                  grupoCentralizadorDisabled={grupoCentralizadorDisabled}
                  onChangeGrupoProdutoReplicacao={onChangeGrupoProdutoReplicacao}
                  optionGruposProdutoReplicacao={optionGruposProdutoReplicacao}
                  grupoProdutoReplicacaoSelect={grupoProdutoReplicacaoSelect}
                  onChangeSubGrupoMaterial={onChangeSubGrupoMaterial}
                  optionSubGrupoMateriais={optionSubGrupoMateriais}
                  subGrupoMaterialSelect={subGrupoMaterialSelect}
                  onChangeProdutoReplicacao={onChangeProdutoReplicacao}
                  optionProdutosReplicacao={optionProdutosReplicacao}
                  onChangeProdutoReplicacaoMulti={onChangeProdutoReplicacaoMulti}
                  onChangeGrupoCentralizadorReplicacao={onChangeGrupoCentralizadorReplicacao}
                  optionGruposCentralizadoresReplicacao={optionGruposCentralizadoresReplicacao}
                  grupoCentralizadorReplicacaoSelect={grupoCentralizadorReplicacaoSelect}
                />
              </Form>
            )}
          </Formik>

          {!precoRegra && !isLoading && (
            <ResponseAlert
              hideButton={true}
              hideIcon={true}
              text={`Preço regra não encontrado`}
              status="error"
              show={true}
            />
          )}

          {isLoading && (
            <div className="spinner__form">
              <LoaderFull />
            </div>
          )}

          {isOpenInfoAdicionaisModal && (
            <InformacoesAdicionaisModal
              isOpen={isOpenInfoAdicionaisModal}
              onClose={() => {
                setIsOpenInfoAdicionaisModal(false);
              }}
              handleSubmit={handleEnviarNegociacao}
            />
          )}

          {isOpenStatusModal && (
            <StatusModal
              isOpen={isOpenStatusModal}
              title={<>{messageStatusModal}</>}
              sub="Verifique o status na aba de solicitações em até 5 minutos"
              buttonOne={"Ok"}
              onClose={() => {
                setIsOpenStatusModal(false);
                const url = `${initialPath}/${clienteId}/solicitacoes-preco`;
                navigate(url);
              }}
            />
          )}

          {modalValidacao?.isOpen && (
            <ModalAction
              isOpen={modalValidacao?.isOpen}
              title="Atenção"
              sub={modalValidacao?.message}
              buttonOne="Confirmar"
              linkOne={() => {
                setIsOpenInfoAdicionaisModal(true);
                setModalValidacao({ isOpen: false, message: "" });
              }}
              buttonTwo="Cancelar"
              linkTwo={() => setModalValidacao({ isOpen: false, message: "" })}
              onClose={() => setModalValidacao({ isOpen: false, message: "" })}
            />
          )}

          {modalValidacaoError?.isOpen && (
            <ModalResponse
              isOpen={modalValidacaoError?.isOpen}
              status={"warning"}
              message={
                modalValidacaoError?.message ||
                "Ocorreu um erro na validação dos campos preenchidos, verifique se a proposta foi preenchida corretamente!"
              }
              closeModal={() => setModalValidacaoError({ isOpen: false, message: "" })}
            />
          )}

          {modalErrorResponse?.isOpen && (
            <ModalResponse
              isOpen={modalErrorResponse?.isOpen}
              status={"warning"}
              message={
                modalErrorResponse?.message?.includes("<br")
                  ? modalErrorResponse.message.split(/<br\s*\/?>/gi).map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))
                  : modalErrorResponse?.message || "Ocorreu um erro ao processar a solicitação!"
              }
              closeModal={() => setModalErrorResponse({ isOpen: false, message: "" })}
            />
          )}

          {isOpenCondicaoEspecialModal && (
            <CondicaoEspecialModal
              isOpen={isOpenCondicaoEspecialModal}
              handleCancel={handleCancel}
              handleConfirm={handleConfirm}
              onClose={handleCancel}
            />
          )}

          {precoRegra && !isLoading && (
            <ResponseAlert
              hideButton={true}
              hideIcon={true}
              text={`Aprovador: ${aprovadorMaximo?.hierarquia?.nome ?? "-"}`}
              setShow={setResponseShow}
              show={responseShow}
            />
          )}
        </div>
      </main>
    </>
  );
};

const NoInfoOverlay = ({ name, setShowOverlay }) => {
  const overlayRef = useRef(null);

  const handleClick = () => {
    setShowOverlay((prev) => ({
      ...prev,
      [name]: false,
    }));

    overlayRef.current?.parentElement.children[0].getElementsByTagName("input")[0].focus();
  };

  return (
    <div className="absolute w-full top-0 bg-[#E6E6E6]" ref={overlayRef}>
      <Input onClick={handleClick} className="text-center" style={{ fontSize: 14 }} readOnly />
    </div>
  );
};

NoInfoOverlay.propTypes = {
  name: PropTypes.string.isRequired,
  setShowOverlay: PropTypes.func.isRequired,
};

export default PricesTableNegotiation;
